export default __webpack_public_path__ + "9f0520301a6b9ede20d6d35f9918dc6f.jpg";